// World Builder access + category config.
// Server enforces write-access for this email; the client uses it only to show
// the button to the right account.
export const WORLD_BUILDER_EMAIL = 'johannesmidgardr@gmail.com';

export const WB_CATEGORIES = [
  { key: 'buildings', label: 'Buildings' },
  { key: 'walls-gates', label: 'Walls & Gates' },
  { key: 'nature', label: 'Nature' },
  { key: 'props', label: 'Props' },
];
